import { Component, EventEmitter, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { UserProfile } from '../../models';
import { UserService } from '@app/services';
import { ProfileFormComponent } from '../profile-form/profile-form.component';
import { concat } from 'rxjs';

@Component({
    selector: 'profile-settings',
    templateUrl: './profile-settings.component.html',
    styleUrls: ['./profile-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ProfileFormComponent]
})
export class ProfileSettingsComponent implements OnInit {

  @Output() onSave = new EventEmitter();
  @ViewChild('profileForm', { static: true }) profileForm : ProfileFormComponent;

  constructor(readonly userService: UserService) { }

  ngOnInit() {
    this.userService.getProfile().subscribe(
      data => {
        data.dateOfBirth = new Date(data.dateOfBirth);
        this.model = data;

      }, error => {
        this.errorMessage = 'Could not load your profile, try again later.';
        console.error(this.errorMessage + '...' + error);
      });

      this.profileForm.save.subscribe(res =>{
        this.onSave.emit();
      });
  }

  onSubmit() {
    this.wait = true;
    if (this.model.phone) {
      this.model.phone = this.model.phone.replace(/\D+/g, '').replace(/^[01]/, '');
    }

    concat(
      this.userService.updateProfile(this.model),
      this.userService.refresh()
    ).subscribe(() => {
        this.wait = false;
        this.errors = undefined;
        this.onSave.emit();
        this.errorMessage = undefined;
        this.saved = true;
      }, error => {
        const { exceptionType, data } = error;
        if (exceptionType && exceptionType === 'ModelValidation' && data) {
          if (typeof data === 'string') {
            this.errorMessage = data;
          } else {
            this.errors = data.fields;
            this.errorMessage = ' Please correct the errors and try to save again.';
          }
        } else {
          this.errorMessage = error;
          console.error(this.errorMessage);
        }
        this.wait = false;
      });
  }

  model = {} as UserProfile;
  errors;
  errorMessage: string;
  wait = false;
  saved = false;
}
